import { QrCodeDownLoader } from "../../../organisms/QrCodeDownLoader";


export const RouletteQrCode = () => {
  return <QrCodeDownLoader liffType='roulette' />
};